import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// PrimeNG Components
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';

// Application Components
import { MenuComponent } from './menu/menu.component';
import { TopbarLoginComponent } from './topbar-login/topbar-login.component';
import { FooterLoginComponent } from './footer-login/footer-login.component';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { MsgComponent } from './msg/msg.component';
import { AppMenuitemComponent } from './menu/app.menuitem.component';
import { HistorialSolicitudComponent } from './historial-solicitud/historial-solicitud.component';
import { MensajesComponent } from '../../locale/mensajes/mensajes.component';
import { TramiteNotificacionesComponent } from './tramite-notificaciones/tramite-notificaciones.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    AppMenuitemComponent,
    MenuComponent,
    TopbarComponent,
    SpinnerComponent,
    MsgComponent,
    TopbarLoginComponent,
    FooterLoginComponent,
    FooterComponent,
    MensajesComponent,
    HistorialSolicitudComponent,
    TramiteNotificacionesComponent,
  ],
  exports: [
    AppMenuitemComponent,
    MenuComponent,
    TopbarComponent,
    SpinnerComponent,
    MsgComponent,
    TopbarLoginComponent,
    FooterLoginComponent,
    FooterComponent,
    MensajesComponent,
    HistorialSolicitudComponent,
    TramiteNotificacionesComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ProgressSpinnerModule,
    ToastModule,
    DialogModule,
    ButtonModule,
  ],
})
export class ComponentsModule { }
